import { LoaderManagement } from '../loader-management';
import { LoaderNameType } from '../types';
import { UsedLoadersModel } from './used-loaders.model';
import { UsedLoaderModel } from './used-loader.model';

export class LoadersStorageModel {
  private usedLoaders: UsedLoadersModel = new UsedLoadersModel();
  private loaderInstances: any = {};

  public addLoader(_loader: LoaderManagement): void {
    this.loaderInstances[_loader.loaderName] = _loader;
  }

  public incrementLoader(_loaderName: LoaderNameType): void {
    this.usedLoaders.get(_loaderName).increment();
  }

  public decrementLoader(_loaderName: LoaderNameType): void {
    this.usedLoaders.get(_loaderName).decrement();
  }

  public getLoaderStorageByName(_loaderName: LoaderNameType): UsedLoaderModel {
    return this.usedLoaders.get(_loaderName);
  }

  public getLoaderByName(_loaderName: LoaderNameType): LoaderManagement | null {
    const loader: LoaderManagement = this.loaderInstances[_loaderName];

    return loader || null;
  }

  public isUsed(_loaderName: LoaderNameType): boolean {
    return this.usedLoaders.isUsed(_loaderName);
  }
}
